import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ScrollText } from "lucide-react";
import { api } from "@/lib/api";
import { TID } from "@/constants/testIds";
import { formatDateTime } from "@/lib/format";

const ACTION_TONE = {
  login: "bg-emerald-100 text-emerald-800 border-emerald-200",
  login_google: "bg-emerald-100 text-emerald-800 border-emerald-200",
  register: "bg-blue-100 text-blue-800 border-blue-200",
  create: "bg-blue-100 text-blue-800 border-blue-200",
  update: "bg-amber-100 text-amber-800 border-amber-200",
  delete: "bg-rose-100 text-rose-800 border-rose-200",
  suspend: "bg-rose-100 text-rose-800 border-rose-200",
  reactivate: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export default function AdminAudit() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/audit-logs?limit=300").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <Layout title="Auditoria" subtitle="Trilha de todas as ações da plataforma">
      <Card data-testid={TID.adminAudit} className="rounded-xl border-stone-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-stone-50">
              <TableHead className="font-body">Quando</TableHead>
              <TableHead className="font-body">Quem</TableHead>
              <TableHead className="font-body">Ação</TableHead>
              <TableHead className="font-body">Entidade</TableHead>
              <TableHead className="font-body">ID</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-stone-500 py-10">
                  <ScrollText className="h-6 w-6 mx-auto mb-2 text-stone-400" />
                  Sem registros
                </TableCell>
              </TableRow>
            )}
            {items.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="font-body text-sm">{formatDateTime(l.created_at)}</TableCell>
                <TableCell className="font-body text-sm">{l.user_email || l.user_id || "—"}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={ACTION_TONE[l.action] || "bg-stone-100 text-stone-700"}>
                    {l.action}
                  </Badge>
                </TableCell>
                <TableCell className="font-body text-sm capitalize">{l.entity}</TableCell>
                <TableCell className="font-body text-xs text-stone-500">{l.entity_id || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
